"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendMessage = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const direct_attachment_1 = require("./direct-attachment");
const entity_type_1 = require("./entity-type");
const flags_1 = require("./flags");
const handlers_1 = require("./handlers");
exports.SendMessage = typebox_1.Type.Object({
    handler: handlers_1.Handler,
    template: typebox_1.Type.Optional(typebox_1.Type.String()),
    sendAs: typebox_1.Type.Optional(typebox_1.Type.String()),
    sendAfter: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    destination: typebox_1.Type.String(),
    title: typebox_1.Type.Optional(typebox_1.Type.String()),
    body: typebox_1.Type.String(),
    topic: typebox_1.Type.String(),
    flags: typebox_1.Type.Optional(typebox_1.Type.Array(flags_1.NotificationFlag)),
    directAttachments: typebox_1.Type.Optional(typebox_1.Type.Array(direct_attachment_1.DirectAttachment)),
    attachmentS3ItemRefs: typebox_1.Type.Optional(typebox_1.Type.Array(common_1.S3ItemReference)),
    references: typebox_1.Type.Optional(typebox_1.Type.Array(typebox_1.Type.Object({
        entityType: entity_type_1.EntityType,
        id: typebox_1.Type.String(),
    }))),
});
//# sourceMappingURL=send.js.map